import { useContext } from 'react';
import { useQueries as useQueriesOriginal } from 'react-query';

import MessageContext from './MessageContext';

export const useQueries = (queries) => {
  const { showErrorMessage } = useContext(MessageContext);
  return useQueriesOriginal(
    queries.map((q) => ({
      ...q,
      onError: (error) => {
        showErrorMessage(error.message);
        q?.onError?.(error);
      },
    }))
  );
};
